import { render, staticRenderFns } from "./RefreshCache.vue?vue&type=template&id=d262faec&scoped=true&lang=pug&"
import script from "./RefreshCache.vue?vue&type=script&lang=js&"
export * from "./RefreshCache.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d262faec",
  null
  
)

export default component.exports